import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
const Countup = () => {
  return (
    <div>
      <h2>
        <CountUp end="2647152" duration={3.2} redraw={true}>
          {({ countUpRef, start }) => (
            <VisibilitySensor onChange={start} delayedCall>
              <span ref={countUpRef} />
            </VisibilitySensor>
          )}
        </CountUp>{" "}
        {/*<span className="target">+</span>*/}
      </h2>
    </div>
  );
};

export default Countup;
